var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useContext, useEffect } from 'react';
import { useRouter } from '@curi/react-dom';
import { getAuth, FacebookAuthProvider, GoogleAuthProvider, signInWithPopup, } from '@firebase/auth';
import toast from 'react-hot-toast';
import { isEqual, forEach } from 'lodash';
import { ProfileContext } from '__state/Profile';
import { loginWithEmail, increasePartyCount, getUserData, updateUser, getPartyData, } from 'services';
import { getPartyId } from 'utils/helpers';
import HeaderAuth from 'components/HeaderAuth';
import AuthPageNav from 'components/AuthPageNav';
import FacebookIcon from '__assets/images/icon__facebook.svg';
import './Login.scss';
var socialSettings = {
    facebook: {
        provider: FacebookAuthProvider,
        scopes: ['email']
    },
    google: {
        provider: GoogleAuthProvider,
        scopes: ['https://www.googleapis.com/auth/userinfo.email', 'https://www.googleapis.com/auth/userinfo.profile']
    }
};
var baseClass = 'page__login';
var Login = function () {
    var partyId = getPartyId();
    var auth = getAuth();
    var router = useRouter();
    var setProfile = useContext(ProfileContext).setProfile;
    var _a = useState(''), email = _a[0], setEmail = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(false), showPassword = _c[0], setShowPassword = _c[1];
    var _d = useState(), party = _d[0], setParty = _d[1];
    useEffect(function () {
        var getParty = function () { return __awaiter(void 0, void 0, void 0, function () {
            var partySnap, partyData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getPartyData()];
                    case 1:
                        partySnap = _a.sent();
                        partyData = partySnap.data();
                        setParty(partyData);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getParty();
    }, []);
    var completeRegistration = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var userSnap, userProfile, parties, url, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, getUserData(id)];
                case 1:
                    userSnap = _a.sent();
                    userProfile = userSnap.data();
                    parties = userProfile.parties ? userProfile.parties : [partyId];
                    parties = parties.includes(partyId) ? parties : __spreadArray(__spreadArray([], parties, true), [partyId], false);
                    if (!!isEqual(userProfile.parties, parties)) return [3 /*break*/, 4];
                    userProfile.parties = parties;
                    return [4 /*yield*/, updateUser(id, userProfile)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, increasePartyCount()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setProfile(userProfile);
                    url = router.url({ name: "Party" });
                    router.navigate({ url: url });
                    return [3 /*break*/, 6];
                case 5:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var submitLogin = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var user, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loginWithEmail({ email: email, password: password })];
                case 2:
                    user = (_a.sent()).user;
                    completeRegistration(user.uid);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.error(error_3);
                    if (error_3.message) {
                        if (error_3.message.includes("auth/wrong-password") ||
                            error_3.message.includes("auth/invalid-email")) {
                            toast.error('Email or password is incorrect.');
                        }
                    }
                    else {
                        toast.error('Something went wrong logging you in. Please try again or contact us.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var submitSocialLogin = function (network) { return __awaiter(void 0, void 0, void 0, function () {
        var settings, scopes, provider, user, uid, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    settings = socialSettings[network];
                    scopes = settings.scopes;
                    provider = new settings.provider();
                    forEach(scopes, function (scope) {
                        provider.addScope(scope);
                    });
                    provider.setCustomParameters({ 'display': 'popup' });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, signInWithPopup(auth, provider)];
                case 2:
                    user = (_a.sent()).user;
                    if (user) {
                        uid = user.uid;
                        completeRegistration(uid);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    console.error(error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var togglePassword = function (e) {
        e.preventDefault();
        setShowPassword(!showPassword);
    };
    if (!party) {
        return null;
    }
    return (_jsxs("div", __assign({ className: baseClass }, { children: [_jsx(HeaderAuth, { logo: party === null || party === void 0 ? void 0 : party.headerImage, color: party === null || party === void 0 ? void 0 : party.headerColor }, void 0), _jsxs("div", __assign({ className: baseClass + "__title" }, { children: [_jsx("h1", { children: "Log In" }, void 0), _jsx("p", { children: "Log in to chat with Zags during basketball games! Please keep comments respectful." }, void 0)] }), void 0), party.useSocialLogin && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "social-logins" }, { children: _jsxs("button", __assign({ className: "facebook", onClick: function () { return submitSocialLogin('facebook'); } }, { children: [_jsx("img", { alt: "", src: FacebookIcon }, void 0), "Log in with Facebook"] }), void 0) }), void 0), _jsx("div", __assign({ className: "or-divider" }, { children: "OR" }), void 0)] }, void 0)), _jsx("div", __assign({ className: baseClass + "__form" }, { children: _jsxs("form", __assign({ onSubmit: submitLogin }, { children: [_jsxs("div", __assign({ className: "form-row" }, { children: [_jsx("label", __assign({ htmlFor: "email" }, { children: "Email" }), void 0), _jsx("input", { name: "email", type: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, required: true }, void 0)] }), void 0), _jsxs("div", __assign({ className: "form-row" }, { children: [_jsx("label", __assign({ htmlFor: "password" }, { children: "Password" }), void 0), _jsx("input", { name: "password", type: showPassword ? 'text' : 'password', value: password, onChange: function (e) { return setPassword(e.target.value); }, required: true }, void 0), _jsx("button", __assign({ className: "show-password-button", onClick: togglePassword }, { children: showPassword ? 'Hide' : 'Show' }), void 0)] }), void 0), _jsx("div", __assign({ className: "form-row" }, { children: _jsx("input", { type: "submit", value: "Log In", disabled: !email || !password }, void 0) }), void 0)] }), void 0) }), void 0), _jsx(AuthPageNav, { authPage: "login" }, void 0)] }), void 0));
};
export default Login;
